var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var FIREFOX_MAX_ELEMENT_SIZE = 15000000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var isFirefox = function isFirefox() {
  navigator.userAgent.indexOf('Firefox') !== -1;
}

export var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    } else if (isFirefox()) {
      return FIREFOX_MAX_ELEMENT_SIZE
    }

  }

  return DEFAULT_MAX_ELEMENT_SIZE;
};